import EditProtectedEnvironment from './EditProtectedEnvironment';

export default EditProtectedEnvironment;
